import { academicProgramsService } from 'services';

// Feature-local boundary around the legacy application service. Request slices
// depend on this narrow contract instead of the much larger service object.
export const programRequestsApi = {
    getConfiguration: customHandleError =>
        academicProgramsService.getProgramRequestConfiguration(customHandleError),
    getInstitutions: () => academicProgramsService.getInstitutions(),
    getCipCodes: () => academicProgramsService.getSixCips(),
    getDegreeLevels: () => academicProgramsService.getDegreeLevels(),
    getLocations: query => academicProgramsService.getLocations(query),
    getProgramsForInstitution: query =>
        academicProgramsService.getAllProgramDetailsFromInstitution(query),
    getSplitProgramRequests: requestId =>
        academicProgramsService.getSplitProgramRequests(requestId),
    uploadFiles: (files, requestId) =>
        academicProgramsService.uploadFiles(files, requestId),
    createNewProgram: (request, customHandleError) =>
        academicProgramsService.submitNewProgramRequest(request, customHandleError),
    createMergeRequest: (request, customHandleError) =>
        academicProgramsService.submitMergeProgramRequest(request, customHandleError),
    createSplitRequest: (request, customHandleError) =>
        academicProgramsService.submitSplitProgramRequest(request, customHandleError),
    createChangeStatusRequest: (request, customHandleError) =>
        academicProgramsService.submitChangeStatusRequest(request, customHandleError),
    createChangeDetailsRequest: (request, customHandleError) =>
        academicProgramsService.submitChangeDetailsRequest(request, customHandleError),
    createConsolidateRequest: (request, customHandleError) =>
        academicProgramsService.submitConsolidateProgramRequest(request, customHandleError),
    updateNewProgram: (request, customHandleError) =>
        academicProgramsService.updateNewProgramRequest(request, customHandleError),
    updateMergeRequest: (request, customHandleError) =>
        academicProgramsService.updateMergeProgramRequest(request, customHandleError),
    updateSplitRequest: (request, customHandleError) =>
        academicProgramsService.updateSplitProgramRequest(request, customHandleError),
    updateConsolidateRequest: (request, customHandleError) =>
        academicProgramsService.updateConsolidateProgramRequest(request, customHandleError),
    updateChangeStatusRequest: (request, customHandleError) =>
        academicProgramsService.updateChangeStatusRequest(request, customHandleError),
    updateChangeDetailsRequest: (request, customHandleError) =>
        academicProgramsService.updateChangeDetailsRequest(request, customHandleError),
};
